export function taipeiDateKey(now = new Date()) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Taipei", year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(now);
  const value = type => parts.find(part => part.type === type).value;
  return `${value("year")}-${value("month")}-${value("day")}`;
}

export function personnelAccountStatus(profile, dailyStatus) {
  // An incomplete archive write must never make the account appear active again.
  if (profile.accountStatus === "archived" || dailyStatus.accountStatus === "archived") return "archived";
  return profile.accountStatus || dailyStatus.accountStatus || "active";
}

export function personnelStatusFields(profile, dailyStatus) {
  return {
    accountStatus: personnelAccountStatus(profile, dailyStatus),
    // A partial hide/unhide write must not expose a still-hidden employee.
    isHidden: Boolean(profile.isHidden || dailyStatus.isHidden),
    // An explicit empty string clears the date even if the daily copy is stale.
    endDate: profile.endDate ?? dailyStatus.endDate ?? "",
  };
}

export function isFormerPersonnel(person, today = taipeiDateKey()) {
  if (person.accountStatus === "archived" || person.isHidden) return true;
  const date = person.endDate || "";
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return false;
  const parsed = new Date(`${date}T00:00:00Z`);
  if (Number.isNaN(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== date) return false;
  // The employee remains current throughout their final working day in Taiwan.
  return date < today;
}
